import Repository from './Repository'
const resource = '/convert'

export default {
  /**
   * コンバートサマリー取得
   * @param {Number} shopId 店舗ID
   * @param {String} type 物件種別
   */
  async getSummary(shopId, type) {
    const params = {
      shop_id: shopId,
      type: type,
    }
    return await Repository.get(`${resource}/summary/${shopId}`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * コンバート結果取得
   * @param {Array} shopId 店舗ID
   */
  async getResult(shopId) {
    const params = { u_shop_id: shopId }
    return await Repository.get(`${resource}/sending_statuses/${shopId}`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * コンバート履歴取得
   * @param {Array} shopId 店舗ID
   * @param {Array} portalsiteCd サイトCD
   */
  async getHistory(shopId, portalsiteCd) {
    return await Repository.get(`${resource}/sending_statuses/${shopId}/portalsites/${portalsiteCd}`)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * コンバート詳細取得
   * @param {Array} convertResultId コンバート結果ID
   */
  async getDetail(convertResultId) {
    return await Repository.get(`${resource}/sending_statuses/detail/${convertResultId}`)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
}
